import axios from "axios";

export const AuthApis = {
  fetchUserApi: async () => {
    try {
      return await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/profile`,
        {
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error fetching user data:", error);
      throw error;
    }
  },

  googleLogin: async (data) => {
    try {
      return axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/create-google-account`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error during Google login:", error);
      throw error;
    }
  },

  loginUserApi: async (data) => {
    try {
      return axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/login`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error logging in user:", error);
      throw error;
    }
  },

  sendOtpApi: async (data) => {
    console.log("Sending OTP to:", data);
    try {
      return axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/login`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error sending OTP:", error);
      throw error;
    }
  },

  verifyOtpApi: async (data) => {
    try {
      return axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/verify-otp`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
    } catch (error) {
      console.error("Error verifying OTP:", error);
      throw error;
    }
  },

  
  generateInsightsApi: async (patient_id) => {
    try {

        // Detect current page protocol
        const protocol = window.location.protocol; // "http:" or "https:"

        const baseUrl = `${protocol}//${process.env.REACT_APP_DOCTOR_URL}`;

        const response = await axios.get(`${baseUrl}insights/patient/${patient_id}`, {
          //withCredentials: true,
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_DOCTOR_TOKEN}`,
            "Content-Type": "application/json", 
          },
    });

    return response;
    } catch (error) {
      console.error("Error fetching patient insights:", error);
      throw error;
    }
  },

  generateSummaryApi: async (patient_id,conversation_id,current_persona) => {
    try {

        // Detect current page protocol
        const protocol = window.location.protocol; // "http:" or "https:"

        const baseUrl = `${protocol}//${process.env.REACT_APP_DOCTOR_URL}`;

        const response = await axios.get(`${baseUrl}conversation_summary/${patient_id}?conversation_id=${conversation_id}&current_persona=${current_persona}`, {
          //withCredentials: true,
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_DOCTOR_TOKEN}`,
            "Content-Type": "application/json", 
          },
    });

    return response;
    } catch (error) {
      console.error("Error fetching conversation Summary:", error);
      throw error;
    }
  },

  logout: async () => {
    try {
      return axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/v1/auth/logout`,
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.error("There was an error with auth api: ", error);
    }
  },
};
